import FJMobileBG from '../../../common/components/FJMobileBG/FJMobileBG';
import FJHeadline from '../../../common/components/FJHeadline/FJHeadline';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJBlankPanel from '../FJBlankPanel/FJBlankPanel';
import styles from './FJMobileHistory.module.less';
import FJLoading from '../../../common/components/FJLoading/FJLoading';
import FJConstant from '../../../constants/FJConstant';
import FJVirtualizedMixView from '../../../common/components/FJVirtualizedMixView/FJVirtualizedMixView';
import { useRef, useEffect, useState } from 'react';
import FJMobileImageItem from '../FJMobileImageItem/FJMobileImageItem';
import FJMobileSelectAll from '../FJMobileSelectAll/FJMobileSelectAll';
const ITEM_SPACE = 6;

const FJMobileHistory = props => {
    const {
        active = false,
        gotoBack,
        list,
        selectList,
        historyListLoadStatus,
        setSelectList,
        isMobileMultiSelect,
        setIsMobileMultiSelect,
        multiDownload,
        multiDelete,
        previewImage,
    } = props;
    const contentRef = useRef(null);
    const [imgWidth, setImageWidth] = useState(((window.innerWidth || window.screen.width) - 32 - ITEM_SPACE) / 2);
    // const imgWidth = ((window.innerWidth || window.screen.width ) - 38 - ITEM_SPACE) / 2;
    const _getSizeList = () => {
        if (!list || list.length === 0) return [];
        let items = [];
        for (let i = 0; i < list.length; i++) {
            let data = list[i];
            let radio = parseFloat(data.width / data.height);
            let height = imgWidth / radio;
            items.push({ width: imgWidth, height: height });
        }
        return items;
    };
    const onSelected = (id, bool) => {
        if (bool) {
            setSelectList([...selectList, id]);
        } else {
            setSelectList(selectList.filter(i => i !== id));
        }
    };
    const _onShowSelect = () => {
        const bool = !isMobileMultiSelect;
        if (!bool) {
            setSelectList([]);
        }
        setIsMobileMultiSelect(bool);
    };
    const _gotoBack = () => {
        setSelectList([]);
        gotoBack();
    };
    const _renderItem = (itemRect, item) => {
        if (!item) return null;
        const selected = !!selectList?.find(id => id === item.id);
        return (
            <div
                // 会有两个相同id同时渲染的情况
                key={item.type + item.id}
                style={{
                    position: 'absolute',
                    left: itemRect.left,
                    top: itemRect.top,
                    width: itemRect.width,
                    height: itemRect.height,
                }}
            >
                <FJMobileImageItem
                    item={item}
                    selected={selected}
                    onSelected={onSelected}
                    isShowSelected={isMobileMultiSelect}
                    onPreview={previewImage}
                />
            </div>
        );
    };
    // 更新视图
    useEffect(() => {
        if (!contentRef.current) return;
        const containerWidth = contentRef.current._view.offsetWidth;
        const w = (containerWidth - ITEM_SPACE) / 2;
        if (w !== imgWidth) {
            setImageWidth(w);
        }
    }, [imgWidth, active]);

    useEffect(() => {
        contentRef.current?.init && contentRef.current.init();
    }, [imgWidth, contentRef, active]);

    const renderHeaderRight = () => {
        if (!list?.length) return null;
        return (
            <div className={styles.multiple_select} onClick={_onShowSelect}>
                {isMobileMultiSelect ? FJLocalStore._('cancel') : FJLocalStore._('select')}
            </div>
        );
    };
    const hasList = !!list?.length;
    const isLoading = historyListLoadStatus === FJConstant.LOADING;

    return (
        <FJMobileBG active={active}>
            <FJHeadline title={FJLocalStore._('history')} gotoBack={_gotoBack} right={renderHeaderRight()} />
            {hasList && (
                <FJVirtualizedMixView
                    className={styles.inner}
                    list={list || []}
                    row={2}
                    childrenSizeList={_getSizeList(list)}
                    rowSpace={ITEM_SPACE}
                    verticalSpace={ITEM_SPACE}
                    renderItem={_renderItem}
                    ref={contentRef}
                />
            )}
            <div className={styles.loading_box} style={{ display: isLoading || !hasList ? 'flex' : 'none' }}>
                {!hasList && !isLoading && <FJBlankPanel text={FJLocalStore._('no-history-yet')} />}
                {isLoading && <FJLoading strokeColor='#686c7e' />}
            </div>
            <FJMobileSelectAll
                list={list}
                selectList={selectList}
                setSelectList={setSelectList}
                multiDownload={multiDownload}
                multiDelete={multiDelete}
                isMobileMultiSelect={isMobileMultiSelect}
            />
        </FJMobileBG>
    );
};
FJMobileHistory.propTypes = {
    active: PropTypes.bool,
    gotoBack: PropTypes.func,
    creditNumber: PropTypes.number,
    list: PropTypes.array,
    type: PropTypes.string,
    selectList: PropTypes.array,
    setSelectList: PropTypes.func,
    historyListLoadStatus: PropTypes.string,
    isMobileMultiSelect: PropTypes.bool,
    setIsMobileMultiSelect: PropTypes.func,
    multiDownload: PropTypes.func,
    multiDelete: PropTypes.func,
    previewImage: PropTypes.func,
};
export default FJMobileHistory;
